import Link from 'next/link';

// import { useState } from 'react';
import { Heading } from '@/components/dom/text-elements';
import Graph, { GraphProps } from '@/components/graph/index-graph';
import { NormalizeIndexData } from '@/components/index/helpers';
import PerformanceChange, { PerformanceChangeProps } from '@/components/products/performance-change';
import { GetIndexSymbolPublicPath } from '@/helpers/paths';
import cn from '@/lib/cn';
import { IndexSparkRowType } from '@/queries/index-spark-row';

type Props = {
    index: IndexSparkRowType;
    className?: string;
    titleClassName?: string;
    titleLinkClassName?: string;
    graphProps?: Partial<GraphProps>;
    graphClassName?: string;
    performanceChangeProps?: Partial<PerformanceChangeProps>;
    timeRangeLabelText?: string;
};

export const IndexSparkRow = ({
    index,
    titleClassName,
    titleLinkClassName,
    className,
    graphClassName,
    graphProps,
    performanceChangeProps,
    timeRangeLabelText,
}: Props) => {
    const { normalizedIndexData, symbolList } = NormalizeIndexData(index.dailySnapshotsData, index.symbol);
    const performanceValue = index.performanceChange;
    const indexChange = (performanceValue && parseFloat(performanceValue) * 100) || undefined;
    const indexUrl = GetIndexSymbolPublicPath(index.symbol);
    // TODO: pick a `color` for 0% change?
    const color = indexChange && indexChange < 0 ? '#D80275' : '#02D8C3';

    return (
        <div className={cn('flex gap-2', className)}>
            <div className="flex-grow flex-shrink-0 w-1/2">
                <Link
                    href={indexUrl}
                    className={cn(
                        'no-underline text-brand-blue-yves hover:text-brand-blue-nu visited:text-brand-blue-yves line-clamp-2 mb-4',
                        titleLinkClassName
                    )}
                    title={index.name}
                >
                    <Heading
                        importance={4}
                        className={cn('text-brand-blue-yves', titleClassName)}
                    >
                        {index.name}
                    </Heading>
                </Link>

                {indexChange !== undefined ? (
                    <div className="flex items-center gap-2">
                        <PerformanceChange
                            percentChange={parseFloat(indexChange.toFixed(2))}
                            hasBackground={true}
                            {...performanceChangeProps}
                        />
                        {timeRangeLabelText && <span className="text-brand-gray-darker">{timeRangeLabelText}</span>}
                    </div>
                ) : (
                    <></>
                )}
            </div>

            <div className={cn('flex-grow-0 flex-shrink-0 w-1/2', graphClassName)}>
                {normalizedIndexData.length > 0 ? (
                    <Graph
                        indexData={normalizedIndexData}
                        symbolList={symbolList}
                        height={150}
                        showTooltip={false}
                        showLegend={false}
                        showXLabels={false}
                        showYLabels={false}
                        cursor="pointer"
                        lineColor={color}
                        {...graphProps}
                    />
                ) : (
                    <></>
                )}
            </div>
        </div>
    );
};
